import {
    ButtonPrimary,
    IconCheckRegular,
    IconMessageRegular,
    InfoFeedbackScreen,
    Row,
    RowList,
    skinVars,
} from '@telefonica/mistica';
import { t } from 'i18next';
import { continueChangeOwnership } from '../../../../services/OwnershipChangeService';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import { useChangeOwnershipContext } from '../../../../context/change-ownership-context/ChangeOwnershipContext';
import { ContinueSignContract } from '../../../../models/OwnershipChange';
import { useEffect } from 'react';

const ContinueChangeOwnership = () => {
    const navigate = useNavigate();
    const { newCustomer, ibanInterested, contactMediaOTP, dataChangeOwnership, customerId } =
        useChangeOwnershipContext();
    const changeOwnershipFlow = localStorage.getItem('changeOwnershipFlow');
    const escalation = sessionStorage.getItem('escalationInfoOpen');
    const infoEscalation = JSON.parse(escalation!);

    useEffect(() => {
        if (changeOwnershipFlow === 'newCustomer' && !newCustomer.iban) navigate('/change-ownership/new-user');
    }, []);

    const handleContinue = async () => {
        const data: ContinueSignContract = {
            signalingId: dataChangeOwnership?.signalingId || infoEscalation?.signalingId,
            contactMediaOTPValue: changeOwnershipFlow === 'newCustomer' ? newCustomer.contactPhone : contactMediaOTP,
            iban: changeOwnershipFlow === 'newCustomer' ? newCustomer?.iban : ibanInterested,
            customerId: changeOwnershipFlow === 'newCustomer' ? customerId || '' : undefined,
            email: changeOwnershipFlow === 'newCustomer' ? newCustomer.email : undefined,
        };
        try {
            const response = await continueChangeOwnership(data);
            navigate('/change-ownership/sing-contract', { state: { url: response.data.url } });
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className='continue-change-ownership'>
            <InfoFeedbackScreen
                title={t('changeHolderNextStepsTitle')}
                Icon={() => <IconMessageRegular color={skinVars.colors.brand} size={48} />}
                extra={
                    <RowList>
                        <Row title={t('changeHolderNextStepsTitle1')} asset={<IconCheckRegular size={24} />} />
                        <Row title={t('changeHolderNextStepsTitle2')} asset={<IconCheckRegular size={24} />} />
                        <Row title={t('changeHolderNextStepsTitle3')} asset={<IconCheckRegular size={24} />} />
                    </RowList>
                }
                primaryButton={<ButtonPrimary onPress={handleContinue}>{t('onboardingFirstVerButton')}</ButtonPrimary>}
            />
        </div>
    );
};

export default ContinueChangeOwnership;
